export default {
  icons: {
    loading: 'i-ph-circle-notch',
  },
}
